import React from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowRight } from 'lucide-react';

const EventsSection = () => {
  useTranslation();
  return null;


  const events = [
    {
      id: 1,
      titleAr: 'ورش العمل القانونية (قريباً)',
      titleEn: 'Legal Workshops (Coming Soon)',
      descriptionAr:
        'نعمل على إطلاق ورش عمل متخصصة في صياغة العقود والأنظمة التجارية، موجهة للمهتمين وأصحاب الأعمال.',
      descriptionEn:
        'We are working on launching specialized workshops in contract drafting and commercial regulations, designed for interested participants and business owners.',
      image: '/images/wazin-seminars.jpeg',
      category: 'مبادرة',
      categoryEn: 'Initiative'
    },
    {
      id: 2,
      titleAr: 'أيام الاستشارات المفتوحة (قريباً)',
      titleEn: 'Open Consultation Days (Coming Soon)',
      descriptionAr:
        'نستهدف تقديم مبادرات لتوفير استشارات قانونية ميسّرة للمستفيدين، بما يعزز الوصول للخدمة القانونية.',
      descriptionEn:
        'We aim to introduce initiatives that provide accessible legal consultations for beneficiaries, improving access to legal services.',
      image: '/images/wazin-meeting.jpeg',
      category: 'مبادرة',
      categoryEn: 'Initiative'
    },
    {
      id: 3,
      titleAr: 'ندوات قانونية متخصصة (قريباً)',
      titleEn: 'Specialized Legal Seminars (Coming Soon)',
      descriptionAr:
        'نعمل على تنظيم ندوات قانونية تناقش أبرز التحديثات النظامية وتأثيرها على بيئة الأعمال.',
      descriptionEn:
        'We are preparing specialized legal seminars to discuss key regulatory updates and their impact on the business environment.',
      image: '/images/wazin-workshop.jpeg',
      category: 'مبادرة',
      categoryEn: 'Initiative'
    }
  ];

  return (
    <section className="py-24 px-4 bg-white" id="events">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-wazin-navy mb-4">
            {i18n.language === 'ar' ? 'مبادرات وازن القانونية' : 'Wazin Legal Initiatives'}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {i18n.language === 'ar'
              ? 'نعمل في وازن على تقديم مبادرات وورش عمل قانونية تستهدف نشر الوعي وتطوير المعرفة القانونية للأفراد وقطاع الأعمال.'
              : 'At Wazin, we work on delivering legal initiatives and workshops aimed at raising awareness and advancing legal knowledge for individuals and the business sector.'}
          </p>
        </div>

        {/* Events Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {events.map((event, index) => (
            <div
              key={event.id}
              className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100"
              dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              {/* Image with Overlay */}
              <div className="relative h-56 overflow-hidden">
                <img
                  src={event.image}
                  alt={i18n.language === 'ar' ? event.titleAr : event.titleEn}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                {/* Gradient Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-wazin-navy/90 via-wazin-navy/40 to-transparent"></div>

                {/* Category Badge */}
                <div className="absolute top-4 right-4 bg-wazin-gold text-white px-4 py-2 rounded-full font-bold text-sm shadow-lg">
                  {i18n.language === 'ar' ? event.category : event.categoryEn}
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                {/* Title */}
                <h3 className="text-xl font-bold text-wazin-navy mb-3 line-clamp-2 group-hover:text-wazin-gold transition-colors duration-250">
                  {i18n.language === 'ar' ? event.titleAr : event.titleEn}
                </h3>

                {/* Description */}
                <p className="text-gray-600 mb-4 line-clamp-3 text-sm">
                  {i18n.language === 'ar' ? event.descriptionAr : event.descriptionEn}
                </p>

                {/* Register Button */}
                <button className="w-full flex items-center justify-center gap-2 bg-wazin-gold text-white py-3 rounded-lg font-bold hover:bg-wazin-gold-dark transition-all duration-250 shadow-sm hover:shadow-md group">
                  <span>{i18n.language === 'ar' ? 'سيتم الإعلان قريباً' : 'To Be Announced Soon'}</span>
                  <ArrowRight className={`w-4 h-4 group-hover:translate-x-1 transition-transform ${i18n.language === 'ar' ? 'rotate-180' : ''}`} />
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* View All Events Button */}
        <div className="text-center mt-12">
          <button className="px-10 py-4 bg-wazin-navy text-white font-bold rounded-lg hover:bg-wazin-navy/90 transition-all duration-250 shadow-lg hover:shadow-xl">
            {i18n.language === 'ar' ? 'عرض جميع المبادرات' : 'View All Initiatives'}
          </button>
        </div>
      </div>
    </section>
  );
};

export default EventsSection;
